import { render, staticRenderFns } from "./order-status-info.vue?vue&type=template&id=28b7241d&"
import script from "./order-status-info.vue?vue&type=script&lang=js&"
export * from "./order-status-info.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\公司文件\\web\\uni-platform\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('28b7241d')) {
      api.createRecord('28b7241d', component.options)
    } else {
      api.reload('28b7241d', component.options)
    }
    module.hot.accept("./order-status-info.vue?vue&type=template&id=28b7241d&", function () {
      api.rerender('28b7241d', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/router/views/device-manage/order-status/order-status-info.vue"
export default component.exports